import { notify } from 'utils/reduxUtils';

export const types = {
  SUPPLIER_FACILITIES_FETCH_ERROR:
    'supplierFacilities/SUPPLIER_FACILITIES_FETCH_ERROR',
  SUPPLIER_FACILITIES_FETCH_REQUEST:
    'supplierFacilities/SUPPLIER_FACILITIES_FETCH_REQUEST',
  SUPPLIER_FACILITIES_FETCH_SUCCESS:
    'supplierFacilities/SUPPLIER_FACILITIES_FETCH_SUCCESS',
  UPDATE_SUPPLIER_FACILITY_ERROR:
    'supplierFacilities/UPDATE_SUPPLIER_FACILITY_ERROR',
  UPDATE_SUPPLIER_FACILITY_REQUEST:
    'supplierFacilities/UPDATE_SUPPLIER_FACILITY_REQUEST',
  UPDATE_SUPPLIER_FACILITY_SUCCESS:
    'supplierFacilities/UPDATE_SUPPLIER_FACILITY_SUCCESS',
};

export const supplierFacilitiesFetch = {
  error: notify(
    (error) => ({
      type: types.SUPPLIER_FACILITIES_FETCH_ERROR,
      payload: error,
    }),
    "Can't fetch supplier facilities",
  ),
  request: () => ({
    type: types.SUPPLIER_FACILITIES_FETCH_REQUEST,
  }),
  success: ({ supplierFacilities }) => ({
    type: types.SUPPLIER_FACILITIES_FETCH_SUCCESS,
    payload: { supplierFacilities },
  }),
};

export const updateSupplierFacility = {
  error: notify(
    (error) => ({
      type: types.UPDATE_SUPPLIER_FACILITY_ERROR,
      payload: error,
    }),
    "Can't update supplier facility",
  ),
  request: ({ supplierFacilityId, data }) => ({
    type: types.UPDATE_SUPPLIER_FACILITY_REQUEST,
    payload: { supplierFacilityId, data },
  }),
  success: () => ({
    type: types.UPDATE_SUPPLIER_FACILITY_SUCCESS,
  }),
};
